<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'app',
}
</script>


// WEBPACK FOOTER //
// App.vue?324c8b32